import { Plug } from '@brandfolder/icons';
import React, { FunctionComponent } from 'react';

const iconStyle: React.CSSProperties = {
  display: 'inline-block',
  lineHeight: 1,
  verticalAlign: 'middle',
  width: '18px',
  height: '18px',
};

export const PlugIcon: FunctionComponent = () => (
  <Plug height={18} style={iconStyle} width={18} />
);
